/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-02-28 00:00:00
 *
 *******************************************************/
import _ from 'lodash';
import React, { Component } from 'react';
import { Button, Popover, ActionList, Icon } from '@shopify/polaris';
import { MobileHorizontalDotsMajor } from '@shopify/polaris-icons';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import history from 'src/routes/history';
import { routes } from 'src/routes';
import { KEY_PREV_ROUTE_SI_CODE_EDITOR, savePrevRoute } from 'src/helpers/session-storage-helper';

type Props = {
  onChangeTemplate: Function,
  onManageTemplate: Function,
  isTemplateLibrary: boolean,
  templateInstance: any
};

type ComposedProps = Props & WithI18nProps;

class PopoverActionManageButton extends Component<ComposedProps> {
  state = {
    active: false
  };

  togglePopover = () => {
    this.setState(({ active }) => {
      return { active: !active };
    });
  };

  checkLinkedWithLiveTheme = templateInstance => {
    const { themes = [] } = this.props;
    const themeIds = _.get(templateInstance, 'themeIds', []);

    let linkedWithLiveTheme = false;
    for (const themeId of themeIds) {
      if (linkedWithLiveTheme) break;

      const themeDetails = _.find(themes, { id: themeId });
      if (!_.isEmpty(themeDetails) && themeDetails.role === 'main') {
        linkedWithLiveTheme = true;
      }
    }

    return linkedWithLiveTheme;
  };

  render() {
    const {
      i18n,

      // onPreview,
      onDuplicateTemplate,
      onEditNameTemplate,
      onRemoveTemplate,
      onChangeTemplate,

      templateId,
      currentTemplateId,
      isReachLimitCustomTemplate = false,
      disabled,
      isTemplateLibrary,
      templateInstance
    } = this.props;
    const { active } = this.state;

    const activator = (
      <div className="activator">
        <Button onClick={this.togglePopover} disabled={disabled}>
          <span style={{ display: 'flex', alignItems: 'center' }}>
            <Icon source={MobileHorizontalDotsMajor} />
          </span>
        </Button>
      </div>
    );

    const isLiveTemplate = this.checkLinkedWithLiveTheme(templateInstance);

    const items = [
      {
        content: i18n.translate('AdminHTML.ShopifyIntegration.Actions.editName'),
        onAction: () => {
          this.togglePopover();
          onEditNameTemplate();
        }
      },
      // {
      //   id: 'item-preview-template',
      //   content: i18n.translate('AdminHTML.ShopifyIntegration.Actions.preview'),
      //   onAction: () => {
      //     this.togglePopover();
      //     onPreview();
      //   }
      // },
      {
        content: i18n.translate('AdminHTML.ShopifyIntegration.Actions.duplicate'),
        disabled: isReachLimitCustomTemplate,
        onAction: () => {
          this.togglePopover();
          onDuplicateTemplate();
        }
      },
      {
        id: 'item-change-template',
        content: i18n.translate('AdminHTML.ShopifyIntegration.Actions.change'),
        onAction: () => {
          this.togglePopover();
          onChangeTemplate();
        },
        disabled: currentTemplateId === templateId
      },
      {
        content: i18n.translate('AdminHTML.ShopifyIntegration.Actions.editCode'),
        onAction: () => {
          this.togglePopover();
          savePrevRoute(
            isTemplateLibrary
              ? routes.shopifyIntegration.templateLibrary()
              : routes.shopifyIntegration.manageTemplateInstance(),
            KEY_PREV_ROUTE_SI_CODE_EDITOR
          );
          history.push(routes.shopifyIntegration.codeEditor(templateId));
        }
      },
      {
        id: 'item-remove-template',
        content: i18n.translate('AdminHTML.ShopifyIntegration.Actions.remove'),
        onAction: () => {
          this.togglePopover();
          onRemoveTemplate();
        }
      }
    ];

    // Hide remove item, change item for current template
    if (templateId === currentTemplateId || isLiveTemplate) {
      _.remove(items, item => {
        return _.includes(['item-remove-template', 'item-change-template'], item.id);
      });
    }
    //  else {
    //   // Remove preview item for other templates
    //   _.remove(items, item => {
    //     return _.includes(['item-preview-template'], item.id);
    //   });
    // }

    if (!onChangeTemplate) {
      _.remove(items, item => {
        return _.includes(['item-change-template'], item.id);
      });
    }

    return (
      <Popover active={active} activator={activator} onClose={this.togglePopover}>
        <Popover.Pane>
          <ActionList items={items} />
        </Popover.Pane>
      </Popover>
    );
  }
}

export default withI18n()(PopoverActionManageButton);
